(function () {
    'use strict';
    var controllerId = 'sentPEC';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'accreditamento', sentPEC]);

    function sentPEC($scope, datacontext, sectionMenu, $uibModalInstance, accreditamento) {
        $scope.accreditamento = jQuery.extend({}, accreditamento); //Clona oggetto
        $scope.accreditamento.SentPEC = true;

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
        };

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.accreditamento);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.cndAccreditamento_setStatus(item).then(function (data) {
                return data;
            });
        }

    }
})();